import { isAudioWorkletNode } from '../guards/audio-worklet-node';
import { setInternalState } from './set-internal-state';
// Set the internalState of the audioNode to 'passive' if it is not an AudioWorkletNode and if it has no 'active' input connections.
export const setInternalStateToPassiveWhenNecessary = (audioNode, activeInputs) => {
    if (!isAudioWorkletNode(audioNode) && activeInputs.every((connections) => (connections.size === 0))) {
        setInternalState(audioNode, 'passive');
    }
};
//# sourceMappingURL=/build/es2018/helpers/set-internal-state-to-passive-when-necessary.js.map